import { render, staticRenderFns } from "./bidedit.vue?vue&type=template&id=669dbb5c&"
import script from "./bidedit.vue?vue&type=script&lang=js&"
export * from "./bidedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports